import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { useLayoutEffect, useRef, useCallback } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import Slider from "react-slick";
import { withRouter } from "../../Helpers/withRouter";
import classnames from "classnames";
import CookieManager from "../../Utils/CookieManager";
import { withComponentDependency } from "../../ComponentDependency/withComponentDependency";
import DependencyManager from "../../DependencyManager";
import SliderArrow from "./SliderArrow/SliderArrow";
var css = {
  "cardContainerRecentActivity": "oalp-z-69A",
  "tagImage": "oalp-2wojm",
  "tagImgContainer": "oalp-3a4bs",
  "withArrows": "oalp-3Tjpb",
  "showAllCard": "oalp-1Oy6b",
  "viewAllCarouselItem": "oalp-3WJdN",
  "withoutVasStrip": "oalp-pnyls",
  "searchIcon": "oalp-3ocHx",
  "viewAllBtn": "oalp-5yLiQ",
  "loaderContainer": "oalp-2ux_m",
  "buyEngager": "oalp-ZRk0-",
  "desktop": "oalp-1SH6F",
  "bundleCard": "oalp-2luRH",
  "zrpWidget": "oalp-lyTug",
  "mobile": "oalp-SOj54",
  "autoHeight": "oalp-1OvP1",
  "expandTrack": "oalp-3zjlT",
  "bannerSlider": "oalp-3HbLA",
  "title": "oalp-8llsP",
  "showAllLink": "oalp-20YKf",
  "bundleEmptyContainer": "oalp-2YohC",
  "empty": "oalp-1mVAm",
  "overlay": "oalp-1Rn7G"
};
import { mobileBreakPoints } from "../../Constants/bundle";
import withConfig from "../../ComponentDependency/withConfig";
import { UNKNOWN } from "../../Constants/locations";
import { getTrackingOrigin } from "../../Store/Selectors/layout";
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
import { getLocationUrl } from "../../Helpers/bundle";
import ImageWrapper from "../ImageWrapper/ImageWrapper";
import EmptyCarComponent from "../EmptyCarComponent/EmptyCarComponent";
import { FormattedMessage as Translation } from "react-intl";
var THRESHOLD_TOTAL = 6;
var AVG_INTERSECTION_RATIO = 0.47;
var INTIAL_THRESHOLD = 0;
var THRESHOLD_DIFF = 0.1;
var THRESHOLDS = _toConsumableArray(new Array(THRESHOLD_TOTAL)).map(function (_, i) {
  return INTIAL_THRESHOLD + THRESHOLD_DIFF * i;
});
var LOGO_LEFT_INITIAL = 44;
var LOGO_LEFT_THRESHOLD = 16;
export var Bundle = function Bundle(_ref) {
  var _classnames;
  var ItemCard = _ref.ItemCard,
    count = _ref.count,
    showAllUrl = _ref.showAllUrl,
    _ref$sliderSettings = _ref.sliderSettings,
    sliderSettings = _ref$sliderSettings === void 0 ? {} : _ref$sliderSettings,
    selectedTab = _ref.selectedTab,
    source = _ref.source,
    EmptyCenter = _ref.EmptyCenter,
    _ref$hideViewAllCard = _ref.hideViewAllCard,
    hideViewAllCard = _ref$hideViewAllCard === void 0 ? false : _ref$hideViewAllCard,
    track = _ref.track,
    widgetKey = _ref.widgetKey,
    locationId = _ref.locationId,
    browsingMode = _ref.browsingMode,
    origin = _ref.origin,
    metadata = _ref.metadata,
    location = _ref.location,
    router = _ref.router,
    VasSheetAsync = _ref.VasSheetAsync,
    templateName = _ref.templateName,
    name = _ref.name,
    onItemView = _ref.onItemView,
    _ref$showOriginalTitl = _ref.showOriginalTitle,
    showOriginalTitle = _ref$showOriginalTitl === void 0 ? false : _ref$showOriginalTitl,
    _ref$showSubTitle = _ref.showSubTitle,
    showSubTitle = _ref$showSubTitle === void 0 ? false : _ref$showSubTitle,
    _ref$showSubDetails = _ref.showSubDetails,
    showSubDetails = _ref$showSubDetails === void 0 ? false : _ref$showSubDetails,
    showTagInFirstCard = _ref.showTagInFirstCard,
    tagImage = _ref.tagImage,
    ReactObserver = _ref.ReactObserver,
    visualizationType = _ref.visualizationType,
    showYearInVasSheet = _ref.showYearInVasSheet,
    _ref$showFullPrice = _ref.showFullPrice,
    showFullPrice = _ref$showFullPrice === void 0 ? true : _ref$showFullPrice,
    _ref$showOlxAutosAdCa = _ref.showOlxAutosAdCardTag,
    showOlxAutosAdCardTag = _ref$showOlxAutosAdCa === void 0 ? true : _ref$showOlxAutosAdCa,
    selectFrom = _ref.selectFrom,
    showMakeModel = _ref.showMakeModel,
    _ref$showEmiPlaceHold = _ref.showEmiPlaceHolder,
    showEmiPlaceHolder = _ref$showEmiPlaceHold === void 0 ? true : _ref$showEmiPlaceHold,
    _ref$showVasStrip = _ref.showVasStrip,
    showVasStrip = _ref$showVasStrip === void 0 ? true : _ref$showVasStrip,
    responsiveBreakpoints = _ref.responsiveBreakpoints,
    zrpWidget = _ref.zrpWidget,
    widgetType = _ref.widgetType,
    config = _ref.config;
  var _a, _b;
  var slider = useRef(null);
  var firstCardRef = useRef(null);
  var tagImageRef = useRef(null);
  var cardContainerRef = useRef(null);
  var isOlxMobbi = config === null || config === void 0 ? void 0 : config.get("isOlxMobbi");
  var vasHash = "#".concat(widgetKey);
  useLayoutEffect(function () {
    if (slider && slider.current) {
      slider.current.slickGoTo(0);
    }
  }, [selectedTab]);
  var handleAnimation = useCallback(function () {
    var img = document.querySelector("#".concat(tagImage === null || tagImage === void 0 ? void 0 : tagImage.alt));
    if (tagImageRef.current) {
      for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
        props[_key] = arguments[_key];
      }
      var intersectionRatio = props[1].intersectionRatio > AVG_INTERSECTION_RATIO ? 1 : props[1].intersectionRatio;
      tagImageRef.current.style.opacity = intersectionRatio;
      if (img) {
        var left = intersectionRatio * LOGO_LEFT_INITIAL < LOGO_LEFT_THRESHOLD ? LOGO_LEFT_THRESHOLD : intersectionRatio * LOGO_LEFT_INITIAL;
        img.style.left = "".concat(left, "px");
      }
    }
  }, [tagImage === null || tagImage === void 0 ? void 0 : tagImage.alt]);
  var clickHandler = useCallback(function () {
    if (track && metadata && metadata.trackingInfo && metadata.trackingInfo.clickEvent && metadata.trackingInfo.clickEvent.name) {
      var trackingName = metadata.trackingInfo.clickEvent.name;
      var trackingInfo = TrackingInfoManager.getTrackingInfo({
        variants_shown: widgetKey,
        browsing_location_id: locationId || UNKNOWN,
        browsing_mode: browsingMode,
        origin: origin,
        chosen_option: "",
        reason: "show_everything",
        resultset_type: metadata === null || metadata === void 0 ? void 0 : metadata.resultsetType
      });
      if (templateName === "BuyEngagerWidget" && name) {
        trackingInfo["chosen_option"] = name;
        trackingInfo["resultset_type"] = templateName;
        trackingName = metadata.trackingInfo.clickEventSeeMore.name;
      }
      track(trackingName, trackingInfo);
    }
    if (showAllUrl) {
      var stateObj;
      if (zrpWidget) {
        stateObj = {
          state: {
            select_from: "rf_".concat(widgetType)
          }
        };
      }
      router === null || router === void 0 ? void 0 : router.push(isOlxMobbi ? "/olxmobbi".concat(showAllUrl) : showAllUrl, stateObj);
    }
  }, [browsingMode, locationId, origin, router, showAllUrl, track, widgetKey, metadata, name, templateName]);
  var keyLocalStorage = "recentActivity";
  if (!isOlxMobbi) {
    keyLocalStorage = "recentActivityOlx";
  }
  var recentActivityString = window.sessionStorage.getItem(keyLocalStorage);
  var recentActivity = [];
  if (recentActivityString) {
    recentActivity = JSON.parse(recentActivityString);
  }
  var isViewAllCardVisible = !hideViewAllCard && showAllUrl && recentActivity.length;
  var breakpointsMobile = responsiveBreakpoints || mobileBreakPoints;
  var commonSetting = {
    dots: false,
    lazyLoad: "ondemand",
    infinite: false,
    swipeToSlide: true,
    focusOnSelect: false,
    slidesToShow: recentActivity.length ? Math.min(count, Object.keys(recentActivity).length + (isViewAllCardVisible ? 1 : 0)) : count
  };
  var settings_desktop = Object.assign(Object.assign({}, commonSetting), {
    arrows: true,
    slidesToScroll: Math.trunc(count),
    nextArrow: /*#__PURE__*/React.createElement(SliderArrow, {
      iconName: "arrowRight",
      size: 20
    }),
    prevArrow: /*#__PURE__*/React.createElement(SliderArrow, {
      iconName: "arrowLeft",
      size: 20
    })
  });
  var settings_mobile = Object.assign(Object.assign({}, commonSetting), {
    arrows: false,
    responsive: Object.keys(breakpointsMobile).map(function (size) {
      return {
        breakpoint: Number(size),
        settings: {
          slidesToShow: breakpointsMobile[size]
        }
      };
    }),
    variableWidth: source === "homePageBundles"
  });
  var PanameraConstants = DependencyManager.getDependency("constants");
  var settings = Object.assign(Object.assign({}, PanameraConstants.platform === "desktop" ? settings_desktop : settings_mobile), sliderSettings);
  var openModal = useCallback(function () {
    var locationUrl = getLocationUrl(location);
    var updatedUrl = "".concat(locationUrl);
    if (!locationUrl.includes(vasHash)) {
      updatedUrl = "".concat(locationUrl).concat(vasHash);
    }
    router === null || router === void 0 ? void 0 : router.push(updatedUrl);
  }, [location, router, vasHash]);
  var closeModal = useCallback(function () {
    var _a, _b;
    var locationUrl = getLocationUrl(location);
    if ((_b = (_a = location === null || location === void 0 ? void 0 : location.hash) === null || _a === void 0 ? void 0 : _a.includes) === null || _b === void 0 ? void 0 : _b.call(_a, vasHash)) {
      locationUrl = locationUrl.split("#")[0];
      router === null || router === void 0 ? void 0 : router.replace(locationUrl);
    }
  }, [location, router, vasHash]);
  var saveItem = function saveItem(item) {
    window.sessionStorage.setItem("click", item);
  };
  if (!ItemCard || !EmptyCenter) {
    return null;
  }
  if (PanameraConstants.platform != "desktop") {
    hideViewAllCard = true;
    showTagInFirstCard = false;
    showYearInVasSheet = true;
    showOlxAutosAdCardTag = true;
    showOriginalTitle = true;
    showSubTitle = true;
    showMakeModel = true;
    showSubDetails = true;
  }
  var bundleItems = recentActivity === null || recentActivity === void 0 ? void 0 : recentActivity.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: "item_".concat(item),
      onClick: function onClick() {
        return saveItem(item.id);
      }
    }, /*#__PURE__*/React.createElement(ItemCard, {
      item: item,
      enabledRealImpressions: true,
      visualizationType: visualizationType || "smallGrid",
      tag: "div",
      listingType: "items",
      onVasTagTap: openModal,
      onView: onItemView,
      showOriginalTitle: showOriginalTitle,
      showSubTitle: showSubTitle,
      showSubDetails: showSubDetails,
      showFullPrice: showFullPrice,
      showOlxAutosAdCardTag: showOlxAutosAdCardTag,
      showMakeModel: showMakeModel,
      selectFrom: selectFrom,
      showEmiPlaceHolder: showEmiPlaceHolder,
      showVasStrip: showVasStrip,
      zrpWidgetType: zrpWidget ? widgetType : ""
    }));
  });
  var tagCard = showTagInFirstCard && recentActivity && !!recentActivity.length ? ReactObserver && /*#__PURE__*/React.createElement(ReactObserver, {
    as: "div",
    onChange: handleAnimation,
    root: cardContainerRef.current,
    threshold: THRESHOLDS,
    rootMargin: "-8px 0px 0px -78px",
    "data-aut-id": "tagObserver"
  }, /*#__PURE__*/React.createElement("div", {
    ref: firstCardRef,
    className: css.tagImgContainer
  })) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classnames(css.title),
    "data-aut-id": "title-recent-activity"
  }, /*#__PURE__*/React.createElement(Translation, {
    id: "recentlyView"
  })), /*#__PURE__*/React.createElement("div", {
    id: "cardContainerRecentActivity",
    className: classnames(recentActivity.length == 0 && css.bannerSlider, css[PanameraConstants.platform], (_classnames = {}, _defineProperty(_classnames, css.buyEngager, source === "buyEngager" || source === "homePageBundles"), _defineProperty(_classnames, css.bundleCard, source === "bundleCard"), _defineProperty(_classnames, css.zrpWidget, zrpWidget === true), _defineProperty(_classnames, css.withArrows, settings.arrows && recentActivity.length + 1 > Math.ceil(count)), _defineProperty(_classnames, css.autoHeight, !!recentActivity.length), _defineProperty(_classnames, css.expandTrack, !!tagImage), _classnames)),
    ref: cardContainerRef
  }, recentActivity.length == 0 ? /*#__PURE__*/React.createElement(EmptyCarComponent, {
    onclick: clickHandler,
    isMobile: PanameraConstants.platform === "mobile",
    isOlxMobbi: isOlxMobbi,
    url: showAllUrl,
    dataAutIdImage: "banner-empty-recent-activity",
    dataAutIdButton: "see-all-btn-recent-activity",
    bannerType: "recent_activity"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, tagCard && tagImage && /*#__PURE__*/React.createElement("div", {
    ref: tagImageRef,
    "data-aut-id": "tagCard"
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    id: tagImage.alt,
    className: css.tagImage,
    image: tagImage
  })), /*#__PURE__*/React.createElement(Slider, Object.assign({
    ref: slider
  }, settings), [tagCard].concat(_toConsumableArray(bundleItems))))), VasSheetAsync && /*#__PURE__*/React.createElement(VasSheetAsync, {
    isOpened: !!((_b = (_a = location === null || location === void 0 ? void 0 : location.hash) === null || _a === void 0 ? void 0 : _a.includes) === null || _b === void 0 ? void 0 : _b.call(_a, vasHash)),
    onVasBottomSheetClose: closeModal,
    overlayClassName: css.overlay,
    showTitle: showOriginalTitle,
    showDisplayDetails: !showSubDetails,
    showYear: showYearInVasSheet,
    showOlxAutosAdCardTag: showOlxAutosAdCardTag
  }));
};
export var mapStateToProps = function mapStateToProps(state, ownProps) {
  var cookies = {
    onap: CookieManager.readCookie("onap") || CookieManager.readCookie("onap_dev") || ""
  };
  var reqProps = {
    cookies: cookies,
    type: "CXE_Bundles"
  };
  return {
    reqProps: reqProps,
    browsingMode: state.track.browsingMode,
    origin: getTrackingOrigin(state, ownProps.location == null ? null : ownProps.location, ownProps.config)
  };
};
export default compose(withComponentDependency, withRouter, withConfig, connect(mapStateToProps, null))(Bundle);